import { completedOrders, webServerDateTime } from 'data/mock-data';

const mock = () => {
  return {
    data: {
      empOnlineOrdersData: completedOrders,
      webServerDateTime,
    },
  };
};

export default mock;
